import { Component, OnDestroy, OnInit } from '@angular/core';
import { CardCircularChartComponent } from '../../components/card-circular-chart/card-circular-chart.component';
import { CardBarlineChartComponent } from '../../components/card-barline-chart/card-barline-chart.component';
import { CardValuePairComponent } from '../../components/card-value-pair/card-value-pair.component';
import { CentroGestion } from '../../models/centro_gestion';
import { forkJoin, Subscription } from 'rxjs';
import { Proveedor } from '../../models/proveedor';
import { OrdenCompraService } from '../../services/api/orden-compra.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
  ID_PERIODO_ANO_ANTERIOR,
  ID_PERIODO_ULTIMOS_SEIS_MESES,
  PERIODOS,
} from '../../constants/list';
import { Periodo } from '../../models/periodo';
import {
  getDateRangeFromMonths,
  getDateRangeFromPreviousYear,
} from '../../utils/period';
import { format, formatToMM } from '../../utils/number';
import { Select } from 'primeng/select';
import { CotizacionService } from '../../services/api/cotizacion.service';
import { CardValuePairExtComponent } from '../../components/card-value-pair-ext/card-value-pair-ext.component';
import { EmpresaService } from '../../services/empresa.service';

@Component({
  selector: 'app-dashboard-oc',
  imports: [
    FormsModule,
    CommonModule,
    CardCircularChartComponent,
    CardBarlineChartComponent,
    CardValuePairComponent,
    Select,
    CardValuePairExtComponent,
  ],
  templateUrl: './dashboard-cot.component.html',
  styleUrl: './dashboard-cot.component.css',
  standalone: true,
})
export class DashboardCotComponent implements OnInit, OnDestroy {
  periodos: Periodo[] = [];
  centrosGestion: CentroGestion[] = [];
  proveedores: Proveedor[] = [];

  selectedPeriodo: number = ID_PERIODO_ULTIMOS_SEIS_MESES;
  selectedCentroGestion: number = 0;
  selectedProveedor: number = 0;

  formattedInvitaciones = '';
  formattedLineasInvitaciones = '';
  formattedProveedoresInvitados = '';
  formattedOfertasProveedores = '';
  formattedOfertas = '';
  formattedLineasOfertas = '';
  formattedCotizacionesAdjudicadas = '';
  formattedLineasAdjudicadas = '';
  formattedOrigenCotizacionesOc = '';
  porcentajeCzOrigenOc: number = 0;
  formattedMontosOrigenCotizacionesOc = '';
  porcentajeMontosOrigenOc: number = 0;
  formattedPromedioApertura = '';
  porcentajeMenor: number = 0;

  labelsCzAdjudicadasMonthly: string[] = [];
  cantidadCantidadCzAdjudicadasMonthly: number[] = [];
  cantidadTotalCzAdjudicadasMonthly: number[] = [];
  ofertaPromomedioInvCzAdjudicadasMonthly: number[] = [];
  ofertaPromomedioAdjCzAdjudicadasMonthly: number[] = [];
  labelsCzProveedoresMonthly: string[] = [];
  provInvitadosCzProveedoresMonthly: number[] = [];
  provRespuestaCzProveedoresMonthly: number[] = [];
  provAdjudicadosCzProveedoresMonthly: number[] = [];
  porcentajeCzProveedoresMonthly: number[] = [];

  formattedPorcentajeCierreAnticipado: string = '';
  formattedPorcentajeReabieraDesierta: string = '';

  colors: string[] = [
    '#FF6B00',
    '#f18b38',
    '#e35903',
    '#e35903',
    '#d38d3a',
    '#ffbc6c',
    '#f98e24',
  ];

  isLoadingInvitaciones: boolean = false;
  isLoadingProveedoresInvitados: boolean = false;
  isloadingOfertas: boolean = false;
  isLoadingCotizacionesAdjudicadas: boolean = false;
  isLoadingOrigenCotizaciones: boolean = false;
  isLoadingMontosOrigenCotizaciones: boolean = false;
  isLoadingPlazoPromedioApertura: boolean = false;
  isLoadingCotizacionesMonthly: boolean = false;
  isLoadingInvitadosMonthly: boolean = false;
  isLoadingPorcentajeEstado: boolean = false;

  private dataSub: Subscription | null = null;
  private invitacionesSub: Subscription | null = null;
  private proveedoresInvitadosSub: Subscription | null = null;
  private ofertasSub: Subscription | null = null;
  private cotizacionesAdjudicadasSub: Subscription | null = null;
  private origenCotizacionesSub: Subscription | null = null;
  private montosOrigenCotizacionesSub: Subscription | null = null;
  private plazoPromedioAperturaSub: Subscription | null = null;
  private cotizacionesMonthtlySub: Subscription | null = null;
  private invitadosMonthlySub: Subscription | null = null;
  private porcentajeEstadoSub: Subscription | null = null;

  constructor(
    private ordenCompraService: OrdenCompraService,
    private cotizacionService: CotizacionService,
    private empresaService: EmpresaService
  ) {}

  ngOnInit() {
    this.periodos = PERIODOS;

    this.isLoadingInvitaciones = true;
    this.isLoadingProveedoresInvitados = true;
    this.isloadingOfertas = true;
    this.isLoadingCotizacionesAdjudicadas = true;
    this.isLoadingOrigenCotizaciones = true;
    this.isLoadingMontosOrigenCotizaciones = true;
    this.isLoadingPlazoPromedioApertura = true;
    this.isLoadingCotizacionesMonthly = true;
    this.isLoadingInvitadosMonthly = true;
    this.isLoadingPorcentajeEstado = true;


    this.dataSub = forkJoin({
      centrosGestion: this.ordenCompraService.getCentrosGestion(),
      proveedores: this.ordenCompraService.getProveedores(),
    }).subscribe({
      next: (data) => {
        let sortedCentrosGestion = data.centrosGestion.sort((a, b) =>
          a.nombre_orgc.localeCompare(b.nombre_orgc)
        );

        let sortedProveedores = data.proveedores.sort((a, b) =>
          a.nombre_empresa.localeCompare(b.nombre_empresa)
        );

        this.centrosGestion = sortedCentrosGestion;
        this.proveedores = sortedProveedores;

        this.loadAllCards();
      },
      error: (err) => {
        console.log('🚀 ~ DashboardCotComponent ~ ngOnInit ~ err:', err);
      },
    });
  }

  ngOnDestroy() {
    if (this.dataSub) {
      this.dataSub.unsubscribe();
    }

    if (this.invitacionesSub) {
      this.invitacionesSub.unsubscribe();
    }

    if (this.proveedoresInvitadosSub) {
      this.proveedoresInvitadosSub.unsubscribe();
    }

    if (this.ofertasSub) {
      this.ofertasSub.unsubscribe();
    }

    if (this.cotizacionesAdjudicadasSub) {
      this.cotizacionesAdjudicadasSub.unsubscribe();
    }

    if (this.origenCotizacionesSub) {
      this.origenCotizacionesSub.unsubscribe();
    }
    if (this.montosOrigenCotizacionesSub) {
      this.montosOrigenCotizacionesSub.unsubscribe();
    }

    if (this.plazoPromedioAperturaSub) {
      this.plazoPromedioAperturaSub.unsubscribe();
    }

    if (this.cotizacionesMonthtlySub) {
      this.cotizacionesMonthtlySub.unsubscribe();
    }

    if (this.invitadosMonthlySub) {
      this.invitadosMonthlySub.unsubscribe();
    }

    if (this.porcentajeEstadoSub) {
      this.porcentajeEstadoSub.unsubscribe();
    }
  }

  loadAllCards() {
    this.fetchInvitaciones();
    this.fetchProveedoresInvitados();
    this.fetchOfertas();
    this.fetchCotizacionesAdjudicadas();
    this.fetchOrigenCotizaciones();
    this.fetchMontosOrigenCotizaciones();
    this.fetchPlazoPromedioApertura();
    this.fetchCotizacionesMonthtly();
    this.fetchInvitadosMonthly();
    this.fetchPorcentajeEstado();
  }

  fetchInvitaciones() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingInvitaciones = true;
    this.invitacionesSub = this.cotizacionService
      .getInvitaciones(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.formattedInvitaciones = format(data.invitaciones);
          this.formattedLineasInvitaciones = format(data.lineas_invitaciones);
        },
        error(err) {
          console.log('🚀 ~ DashboardCotComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingInvitaciones = false;
        },
      });
  }

  fetchProveedoresInvitados() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());

    this.isLoadingProveedoresInvitados = true;

    this.proveedoresInvitadosSub = this.cotizacionService
      .getProveedoresInvitados(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.formattedProveedoresInvitados = format(
            data.proveedores_invitados
          );
          this.formattedOfertasProveedores = format(data.ofertas_proveedores);
        },
        error(err) {
          console.log('🚀 ~ DashboardCotComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingProveedoresInvitados = false;
        },

      });
  }

  fetchOfertas() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());

    this.isloadingOfertas = true;

    this.ofertasSub = this.cotizacionService
      .getOfertas(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.formattedOfertas = format(data.ofertas);
          this.formattedLineasOfertas = format(data.lineas_ofertas);
        },
        error(err) {
          console.log('🚀 ~ DashboardCotComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isloadingOfertas = false;
        },
      });
  }

  fetchCotizacionesAdjudicadas() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingCotizacionesAdjudicadas = true;
    this.cotizacionesAdjudicadasSub = this.cotizacionService
      .getCotizacionesAdjudicadas(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.formattedCotizacionesAdjudicadas = format(
            data.cotizacion_adjudicadas
          );
          this.formattedLineasAdjudicadas = format(data.lineas_adjudicadas);
        },
        error(err) {
          console.log('🚀 ~ DashboardCotComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingCotizacionesAdjudicadas = false;
        },
      });
  }

  fetchOrigenCotizaciones() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingOrigenCotizaciones = true;
    this.origenCotizacionesSub = this.cotizacionService
      .getOrigenCotizaciones(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.formattedOrigenCotizacionesOc = format(
            data.origen_cotizaciones_oc
          );
          this.porcentajeCzOrigenOc = Math.round(data.porcentaje_cz_origen_oc);
        },
        error(err) {
          console.log('🚀 ~ DashboardCotComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingOrigenCotizaciones = false;
        },
      });
  }

  fetchMontosOrigenCotizaciones() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingMontosOrigenCotizaciones = true;
    this.montosOrigenCotizacionesSub = this.cotizacionService
      .getMontosOrigenCotizaciones(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.formattedMontosOrigenCotizacionesOc = formatToMM(
            data.montos_origen_cotizaciones_oc
          );
          this.porcentajeMontosOrigenOc = Math.round(
            data.porcentaje_monto_origen_oc
          );
        },
        error(err) {
          console.log('🚀 ~ DashboardCotComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingMontosOrigenCotizaciones = false;
        },
      });
  }

  fetchPlazoPromedioApertura() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingPlazoPromedioApertura = true;
    this.plazoPromedioAperturaSub = this.cotizacionService
      .getPlazoPromedioApertura(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.formattedPromedioApertura = format(data.promedio_apertura, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          this.porcentajeMenor = Math.round(data.porcentaje_menor);
        },
        error(err) {
          console.log('🚀 ~ DashboardCotComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingPlazoPromedioApertura = false;
        },
      });
  }

  fetchCotizacionesMonthtly() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingCotizacionesMonthly = true;
    this.cotizacionesMonthtlySub = this.cotizacionService
      .getCotizacionesMonthtly(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.labelsCzAdjudicadasMonthly = [];
          this.cantidadCantidadCzAdjudicadasMonthly = [];
          this.cantidadTotalCzAdjudicadasMonthly = [];
          this.ofertaPromomedioInvCzAdjudicadasMonthly = [];
          this.ofertaPromomedioAdjCzAdjudicadasMonthly = [];

          data.map((item) => {
            this.labelsCzAdjudicadasMonthly.push(
              `${item.nombre_mes_corto} ${item.year}`
            );
            this.cantidadCantidadCzAdjudicadasMonthly.push(
              item.cantidad_cz_adjudicadas
            );
            this.cantidadTotalCzAdjudicadasMonthly.push(item.cantidad_total_cz);
            this.ofertaPromomedioInvCzAdjudicadasMonthly.push(item.of_prom_inv);
            this.ofertaPromomedioAdjCzAdjudicadasMonthly.push(item.of_prom_adj);
          });
        },
        error(err) {
          console.log('🚀 ~ DashboardOcComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingCotizacionesMonthly = false;
        },
      });
  }

  fetchInvitadosMonthly() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.empresaService.idEmpresa,
    this.invitacionesSub = this.cotizacionService
      .getInvitadosMonthtly(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.labelsCzProveedoresMonthly = [];
          this.provInvitadosCzProveedoresMonthly = [];
          this.provRespuestaCzProveedoresMonthly = [];
          this.provAdjudicadosCzProveedoresMonthly = [];
          this.porcentajeCzProveedoresMonthly = [];

          data.map((item) => {
            this.labelsCzProveedoresMonthly.push(
              `${item.nombre_mes_corto} ${item.year}`
            );
            this.provInvitadosCzProveedoresMonthly.push(item.prov_invitados);
            this.provRespuestaCzProveedoresMonthly.push(item.prov_respuesta);
            this.provAdjudicadosCzProveedoresMonthly.push(
              item.prov_adjudicados
            );
            this.porcentajeCzProveedoresMonthly.push(item.porcentaje);
          });
        },
        error(err) {
          console.log('🚀 ~ DashboardOcComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingInvitadosMonthly = false;
        },
      });
  }

  fetchPorcentajeEstado() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingPorcentajeEstado = true;
    this.porcentajeEstadoSub = this.cotizacionService
      .getPocentajeEstado(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.formattedPorcentajeCierreAnticipado = `${Math.round(
            data.porc_cierre_anticipado
          )}
          %`;
          this.formattedPorcentajeReabieraDesierta = `${Math.round(
            data.porc_reabierta_desierta
          )}%`;
        },
        error(err) {
          console.log('🚀 ~ DashboardCotComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingPorcentajeEstado = false;
        },
      });
  }

  onPeriodoChange() {
    this.loadAllCards();
  }

  onCentroGestionChange() {
    this.loadAllCards();
  }

  onProveedorChange() {
    this.loadAllCards();
  }

  getDateRange = (): {
    startDate: number;
    endDate: number;
  } => {
    let startDate = 0;
    let endDate = 0;

    switch (+this.selectedPeriodo) {
      case ID_PERIODO_ULTIMOS_SEIS_MESES:
        ({ startDate, endDate } = getDateRangeFromMonths(6));

        break;
      case ID_PERIODO_ANO_ANTERIOR:
        ({ startDate, endDate } = getDateRangeFromPreviousYear());

        break;
      default:
        break;
    }

    return {
      startDate,
      endDate,
    };
  };
  downloadReporteCz() {
    let fechaInicio = 0;
    let fechaFin = 0;
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());

    this.cotizacionService
      .getReporteCz(fechaInicio, fechaFin, this.selectedCentroGestion, this.selectedProveedor)
      .subscribe({
        next: (response) => {
          const blob = new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'reporte_cz.xlsx'; // Nombre del archivo
          document.body.appendChild(a); // Asegura que el elemento esté en el DOM
          a.click();
          document.body.removeChild(a); // Limpia el DOM después de la descarga
          window.URL.revokeObjectURL(url); // Libera el objeto URL
        },
        error: (err) => {
          console.error('Error al descargar el reporte:', err);
        },
        complete: () => {
          console.log('Descarga completada.');
        },
      });
  }
}
